<div class="animations-carousel-panel" #panelEl>
  <top-wave *ngIf="data?.topWave?.value"></top-wave>
  <div class="animations-carousel-panel__content">
    <h2 class="animations-carousel-panel__title"
        #titleEl>
      {{ data.title.value }}
    </h2>
    <div class="mobile-dropdown" (click)="toggleDropdownState()">
      <div *ngFor="let item of animations; let i = index;">
        <div class="mobile-dropdown__container"
             [ngClass]="{'mobile-dropdown__container--opened' : dropdownOpened === dropdownStates.opened}"
             [@dropdown]="item.dropdown"
             (click)="dropdownClick(item, i)">
          <p class="mobile-dropdown__header" [ngClass]="{'mobile-dropdown__header--active' : item.state === animationStates.active}">{{ item.header.value }}</p>
        </div>
      </div>
      <div class="mobile-dropdown__arrow" [class.mobile-dropdown__arrow--opened]="dropdownOpened === dropdownStates.opened"></div>
    </div>

    <div class="animations-carousel-panel__wrapper">
      <div>
        <div *ngFor="let animation of animations; let i = index;">
          <div class="animations-carousel-panel__animation"
               [ngClass]="{'animations-carousel-panel__animation--inactive': animation.state === animationStates.inactive}">
            <div *ngIf="animation.state === animationStates.active">
              <div *ngIf="animation.videoData.video.type === 2 && loadMedia">
                <video preload="true"
                       autoplay="autoplay"
                       [loop]="isClicked"
                       [muted]="'muted'"
                       name="media"
                       (ended)="nextAnimation()"
                       class="animations-carousel-panel__animation--content">
                  <source [src]="animation.videoData.video.url" type="video/mp4">
                </video>
              </div>
              <div *ngIf="animation.videoData.video.type !== 2">
                <!-- Other sources -->
                <div class="animations-carousel-panel__animation--iframe-box"></div>
                <app-iframe class="animations-carousel-panel__animation--content animations-carousel-panel__animation--content-iframe"
                            [src]="animation.videoData.video.url"
                            (onended)="next()">
                </app-iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div *ngFor="let item of animations; let i = index" class="animations-carousel-panel__right">
          <div class="animations-carousel-panel__arrow"
               [ngClass]="{'animations-carousel-panel__arrow--inactive' : item.state === animationStates.inactive}"
               [@arrow]="item.state">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>
          </div>
          <app-animation-carousel-card [item]="item"
                                       (click)="cardClick(item, i)"
                                       [ngClass]="{'animations-carousel-panel__card--active': item.state === animationStates.active}">
          </app-animation-carousel-card>
      </div>
    </div>

  </div>
  <bottom-wave *ngIf="data?.bottomWave?.value"></bottom-wave>
</div>
